import React from 'react';

/**
 * Funil de produção.
 *
 * Não é uma lista de barras: o que importa aqui é a QUEDA entre uma etapa e a
 * seguinte, e por isso a conversão fica escrita entre elas, não ao lado. Quem
 * olha procura onde a perda acontece — e a perda mora no intervalo.
 *
 * A largura é proporcional ao topo do funil, então cada barra também mostra
 * quanto sobrou do começo. As duas leituras convivem: a horizontal é "quanto
 * restou do total", a vertical é "quanto passou da etapa anterior".
 */

const COR = '#2a78d6';
const TRILHO = '#e6f0fd';

const Funil = ({ etapas }) => {
  if (!etapas || etapas.length === 0) return null;

  const topo = Math.max(Number(etapas[0]?.valor) || 0, 1);

  return (
    <div>
      {etapas.map((e, i) => {
        const valor = Number(e.valor) || 0;
        const largura = Math.max((valor / topo) * 100, valor > 0 ? 2 : 0);
        const proxima = etapas[i + 1];

        return (
          <div key={e.etapa}>
            <div className="flex items-center gap-3">
              <div className="w-28 shrink-0 text-xs text-slate-600">{e.etapa}</div>
              <div className="flex-1 min-w-0 rounded-full h-3" style={{ backgroundColor: TRILHO }}>
                <div className="h-full rounded-r-full" style={{ width: `${largura}%`, backgroundColor: COR }} />
              </div>
              <span className="text-sm tabular-nums text-slate-900 font-semibold w-16 text-right shrink-0">
                {valor.toLocaleString('pt-BR')}
              </span>
            </div>

            {/* A conversão vive ENTRE as barras, alinhada ao vão. É a leitura
                que o funil existe para dar; ao lado, ela viraria só mais uma
                coluna de número. */}
            {proxima && (
              <div className="flex items-center gap-3 h-6">
                <div className="w-28 shrink-0" />
                <div className="flex-1 min-w-0 flex items-center gap-2">
                  <span className="text-slate-300 leading-none">↓</span>
                  <span className="text-xs text-slate-500">
                    {proxima.taxa === null || proxima.taxa === undefined
                      ? '—'
                      : <><strong className="text-slate-700">{proxima.taxa}%</strong> passaram</>}
                  </span>
                </div>
                <div className="w-16 shrink-0" />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Funil;
